export function summaPortalProjects(): string {
  return 'summa-portal-projects';
}
